var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{scopedSlots:_vm._u([{key:"menu",fn:function(){return [_c('v-btn',{attrs:{"plain":"","color":"primary","to":"/account/edit","exact":""}},[_c('v-icon',[_vm._v("mdi-tools")]),_vm._v(" Edit ")],1)]},proxy:true},{key:"content",fn:function(){return [_c('router-view')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }